<form #policyRuleForm="ngForm" (ngSubmit)="policyRuleForm.valid && close()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="row">
            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold"><span translate>Rule name</span>*</label>
                    <div>
                        <form-field-input name="name" [(ngModel)]="cRule.name" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.form.get('name')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>
            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('sub_entry')?.invalid && (policyRuleForm.form.get('sub_entry')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold"><span translate>Meta Name</span>*</label>
                    <div>
                        <form-field-input name="sub_entry" [(ngModel)]="cRule.sub_entry" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.form.get('sub_entry')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48 mt-2">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold" for="query" translate>Meta Header Expr</label>:
                    <div class="input-group">
                        <mon-action-menu
                              class="rule-menu-action"
                              *ngIf="cRule.operator"
                              [monActionMenuItems]="dropdownOptions"
                              [monActionMenuClass]="'menu-panel-left-align'"
                              >{{selectedOperator.translation}}</mon-action-menu>

                        <input name="query"
                               data-test="query-starts-with"
                               [required]="true"
                               [(ngModel)]="cRule.query"
                               id="query"
                               [type]="getQueryType()"
                               #queryFormControl="ngModel"
                               class="form-control"
                               [min]="0" />

                        <mon-action-menu
                               class="rule-menu-action"
                               [monActionMenuItems]="dropdownDateAgeOptions"
                               >{{selectedSubEntry?.name}}</mon-action-menu>
                    </div>
                    <div class="form-text text-muted" translate>
                        Define meta headers to match
                    </div>
                    <form-field-errors [input]="queryFormControl" offset="0"></form-field-errors>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <button type="submit"
                [disabled]="policyRuleForm.invalid"
                class="btn btn-border-radius btn-secondary" translate>
            Save
        </button>
    </div>
</form>
